import React, { useState } from "react";
import { RangoButtonMini, RangoFooterColumns } from "@rango/core";
import { FooterViewProps } from "./FooterViews.types";
import { handleLinkButtonClick } from "src/utils/js/handleLinkButtonClick";

const FooterDesktop = ({ gridFooter }: FooterViewProps) => {	

	return (
		<>
			{gridFooter.listColumns?.map((column, index) => (
				<RangoFooterColumns title={column.title} key={index}>
					{column.listColumnItens?.map((item, index) => {
						const targetProps = {
							title: item.target?.title,
							element_parent: item.target?.elementParent,
							element_type: item.target?.elementType,
							destination: item.target?.destination,
						};

						return (
							<RangoButtonMini
								{...targetProps}
								key={index}
								ariaLabel={item.link}
								onMouseDown={(event) => event.preventDefault()}
								onMouseUp={(event) => handleLinkButtonClick(item.link, event)}
							>
								{item.label}
							</RangoButtonMini>
						);
					})}
				</RangoFooterColumns>
			))}
		</>
	);
};

export default FooterDesktop;
